import React from "react";
import Counter from "../../components/counter/Counter";

export default function HeroTwo() {
  return (
    <>
      <section
        className="hero-section pt-100 background-img"
        style={{
          background:
            "url('assets/img/hero-bg-1.jpg')no-repeat center center / cover",
        }}
      >
        <div className="container">
          <div className="row align-items-center justify-content-between">
            <div className="col-md-6 col-lg-6">
              <div className="hero-content-left text-white mt-5">
              <br/>
              <h1 className="text-white">
                  <span>Partnering for Positive Change</span> 
                </h1>
                <br/>  <br/>
                <span className="text-uppercase h6" style={{color:'#2ab9d1'}}> 
                Vision
                </span>
            
                <p className="lead">
                We are the creators of new trends for economic and business development that meet
21st Century challenges through multicultural and interdisciplinary collaborations.
Knowledge, integrity, attentiveness, honesty and speed are the guiding principles of
our company.
                </p>
                <br/><br/><br/><br/><br/>
                

                

                
              </div>
            </div>
            <div className="col-md-6 col-lg-5">
              <div className="hero-animation-img">
               
              </div>
            </div>
          </div>
          
        </div>
      </section>
    </>
  );
}
